<template>
  <common-template>
    <template v-slot:body>
      <index-main />
    </template>
  </common-template>
</template>

<script>
import IndexMain from '@/components/MainContents';
import isMobile from '@/plugins/isMobile';
import CommonTemplate from '@/components/templates/CommonTemplate';
import { signOutAllServices } from '@/utils/auth';

export default {
  name: 'Main',
  mixins: [isMobile],
  components: {
    IndexMain,
    CommonTemplate,
  },
  mounted() {
    const $canonical = document.createElement('link');
    $canonical.rel = 'canonical';
    $canonical.href = `${location.origin}/`;
    document.querySelector('head').appendChild($canonical);
    if (this.$route.query.signoutSSO) {
      signOutAllServices();
    }
  },
};
</script>

<style scoped lang="scss">
@charset "UTF-8";


</style>
